"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const use_places_autocomplete_1 = __importStar(require("use-places-autocomplete"));
const js_api_loader_1 = require("@googlemaps/js-api-loader");
const isNil_1 = __importDefault(require("lodash/isNil"));
const text_input_1 = require("../text-input");
const classnames_1 = __importDefault(require("classnames"));
const address_input_1 = require("../styles/address-input");
const acceptedKeys = ["ArrowUp", "ArrowDown", "Escape", "Enter"];
const AddressInput = ({ apiKey, id, onChange, isError, helpText, className, testId, }) => {
    const [currIndex, setCurrIndex] = (0, react_1.useState)(null);
    const [placeId, setPlaceId] = (0, react_1.useState)("");
    const [cachedVal, setCachedVal] = (0, react_1.useState)("");
    const { init, value, suggestions: { status, data }, setValue, clearSuggestions, } = (0, use_places_autocomplete_1.default)({
        initOnMount: false, // Disable initializing when the component mounts, default is true
        requestOptions: {
            types: ["address"],
            componentRestrictions: { country: "us" },
        },
        debounce: 300,
    });
    (0, react_1.useEffect)(() => {
        const loader = new js_api_loader_1.Loader({
            apiKey: apiKey,
            version: "weekly",
            libraries: ["places"],
        });
        // Callback
        loader.loadCallback(e => {
            if (e) {
                console.log(e);
            }
            init();
        });
    }, []);
    const hasSuggestions = status === "OK";
    const dismissSuggestions = () => {
        setCurrIndex(null);
        clearSuggestions();
    };
    const handleClick = (e) => {
        e.stopPropagation();
        clearSuggestions();
    };
    const getDetailsFunc = (placeId) => {
        (0, use_places_autocomplete_1.getDetails)({ placeId })
            .then(details => {
            const addressObject = mapAddressComponents(details);
            if (typeof onChange === "function" && !(0, isNil_1.default)(addressObject)) {
                onChange(addressObject);
            }
        })
            .catch(error => {
            console.log("Error: ", error);
        });
    };
    (0, react_1.useEffect)(() => {
        const handleClickOutside = () => {
            clearSuggestions();
        };
        window.addEventListener("click", handleClickOutside);
        return () => window.removeEventListener("click", handleClickOutside);
    }, [clearSuggestions]);
    const handleInput = (e) => {
        // Update the keyword of the input element
        const inputValue = e.target.value;
        setValue(inputValue);
        setCachedVal(inputValue);
        onChange(inputValue);
    };
    const handleKeyDown = (e) => {
        if (!hasSuggestions || !acceptedKeys.includes(e.key))
            return;
        if (e.key === "Enter" && placeId) {
            dismissSuggestions();
            getDetailsFunc(placeId);
            dismissSuggestions();
            return;
        }
        if (e.key === "Escape") {
            dismissSuggestions();
            return;
        }
        let nextIndex;
        if (e.key === "ArrowUp") {
            e.preventDefault();
            nextIndex = currIndex ?? data.length;
            nextIndex = nextIndex > 0 ? nextIndex - 1 : null;
        }
        else {
            nextIndex = currIndex ?? -1;
            nextIndex = nextIndex < data.length - 1 ? nextIndex + 1 : null;
        }
        setCurrIndex(nextIndex);
        if (nextIndex !== null) {
            setPlaceId(data[nextIndex].place_id);
            setValue(data[nextIndex]
                ? data[nextIndex].structured_formatting.main_text
                : cachedVal, false);
        }
    };
    const mapAddressComponents = (details) => {
        const { address_components } = details;
        const addressObject = {
            streetNumber: "",
            streetName: "",
            city: "",
            state: "",
            zip: "",
            aptSuiteNumber: "",
        };
        for (const component of address_components) {
            const componentType = component.types[0];
            switch (componentType) {
                case "street_number":
                    addressObject.streetNumber = component.long_name;
                    break;
                case "route":
                    addressObject.streetName = component.long_name;
                    break;
                case "locality":
                    addressObject.city = component.long_name;
                    break;
                case "administrative_area_level_1":
                    addressObject.state = component.short_name;
                    break;
                case "postal_code":
                    addressObject.zip = component.long_name;
                    break;
            }
        }
        return addressObject;
    };
    const handleSelect = (description, place_id) => () => {
        // When user selects a place, we can replace the keyword without request data from API
        // by setting the second parameter to "false"
        getDetailsFunc(place_id);
        setValue(description, false);
        clearSuggestions();
    };
    const renderSuggestions = () => data.map((suggestion, idx) => {
        const { place_id, structured_formatting: { main_text, secondary_text }, } = suggestion;
        return ((0, jsx_runtime_1.jsxs)("li", { id: place_id, role: "option", className: (0, classnames_1.default)((0, address_input_1.addressSuggestionStyles)(idx, currIndex)), onMouseDown: handleSelect(main_text, place_id), children: [main_text, ", ", secondary_text] }, place_id));
    });
    return ((0, jsx_runtime_1.jsxs)("div", { "data-testid": `${testId}-container`, onClick: handleClick, children: [(0, jsx_runtime_1.jsx)(text_input_1.TextInput, { "data-testid": testId, className: className, isError: isError, helpText: helpText, isErrorText: isError, onBlur: () => dismissSuggestions(), "aria-autocomplete": "list", "aria-controls": id || "address-listbox", "aria-expanded": "false", label: "Address", onChange: handleInput, onKeyDown: handleKeyDown, placeholder: "", role: "combobox", value: value }), hasSuggestions && ((0, jsx_runtime_1.jsx)("ul", { "data-testid": "address-suggestion-listbox", id: id || "address-listbox", role: "listbox", "aria-label": "address-suggestions", className: (0, classnames_1.default)((0, address_input_1.addressInputDropDownStyles)()), children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [renderSuggestions(), (0, jsx_runtime_1.jsx)("li", { "data-testid": "address-suggestion-list-item", className: "overflow-hidden", children: (0, jsx_runtime_1.jsx)("img", { className: "float-right", src: "https://developers.google.com/static/maps/documentation/images/google_on_white.png", alt: "Powered by Google" }) })] }) }))] }));
};
exports.AddressInput = AddressInput;
